import { dungApiThat, goiApi } from '../api/http';
import { mayChuHanMucToken } from '../../mock/han-muc-token';
import { mockRequest, mockState } from '../../mock/transport';
import { mayChuTokenAi } from '../../mock/token-ai';
import type {
  AiLimit,
  AiLimitCreate,
  AiLimitUpdate,
  DongPhanRa,
  PhamViHanMucAi,
  SuDungNgay,
  TheoPhanRa,
} from '../../modules/token-ai/types';

/**
 * Màn Token AI của tổ chức (ADR-0123 mục 1, 6, tenant-service): mức sử dụng theo ngày, chia theo tính năng, đơn vị,
 * người dùng, và hạn mức tự đặt. Chọn **lúc gọi** giữa API thật và máy chủ giả (`mock/token-ai.ts`). `tenantId` luôn
 * lấy từ ngữ cảnh đăng nhập.
 */
const goc = (id: string) => `/api/v1/tenants/${encodeURIComponent(id)}`;
const giaLap = <T>(lam: () => T): Promise<T> => mockRequest(undefined).then(lam);

export const tokenAiRepository = {
  /** `GET …/ai-token-quota/daily?from&to` — tối đa 92 ngày. */
  theoNgay: (tenantId: string, from: string, to: string): Promise<SuDungNgay[]> =>
    dungApiThat()
      ? goiApi<{ items: SuDungNgay[] }>(`${goc(tenantId)}/ai-token-quota/daily`, { query: { from, to } }).then((r) => r.items)
      : giaLap(() =>
          mockState() === 'empty' ? [] : mayChuTokenAi.theoNgay(from, to, mayChuHanMucToken.daDungThang(tenantId)).items,
        ),

  /** `GET …/ai-token-quota/breakdown?month=yyyy-MM&theo=` */
  phanRa: (tenantId: string, month: string, theo: TheoPhanRa): Promise<DongPhanRa[]> =>
    dungApiThat()
      ? goiApi<{ items: DongPhanRa[] }>(`${goc(tenantId)}/ai-token-quota/breakdown`, { query: { month, theo } }).then((r) => r.items)
      : giaLap(() =>
          mockState() === 'empty' ? [] : mayChuTokenAi.phanRa(month, theo, mayChuHanMucToken.daDungThang(tenantId)).items,
        ),

  /** `GET …/ai-limits?pham_vi=`. `?mock=filtered-empty` trả rỗng khi đang lọc. */
  danhSachHanMuc: (tenantId: string, phamVi?: PhamViHanMucAi): Promise<AiLimit[]> =>
    dungApiThat()
      ? goiApi<{ items: AiLimit[] }>(`${goc(tenantId)}/ai-limits`, { query: { pham_vi: phamVi } }).then((r) => r.items)
      : giaLap(() =>
          mockState() === 'empty' || (mockState() === 'filtered-empty' && phamVi) ? [] : mayChuTokenAi.danhSachHanMuc(phamVi).items,
        ),

  taoHanMuc: (tenantId: string, du: AiLimitCreate): Promise<AiLimit> =>
    dungApiThat()
      ? goiApi<AiLimit>(`${goc(tenantId)}/ai-limits`, { method: 'POST', body: du })
      : giaLap(() => mayChuTokenAi.taoHanMuc(du)),

  suaHanMuc: (tenantId: string, id: string, du: AiLimitUpdate): Promise<AiLimit> =>
    dungApiThat()
      ? goiApi<AiLimit>(`${goc(tenantId)}/ai-limits/${encodeURIComponent(id)}`, { method: 'PATCH', body: du })
      : giaLap(() => mayChuTokenAi.suaHanMuc(id, du)),

  xoaHanMuc: (tenantId: string, id: string): Promise<void> =>
    dungApiThat()
      ? goiApi<void>(`${goc(tenantId)}/ai-limits/${encodeURIComponent(id)}`, { method: 'DELETE' })
      : giaLap(() => mayChuTokenAi.xoaHanMuc(id)),
};
